import { gql } from '@apollo/client'

export const ACTION_NOTE_FRAGMENT = gql`
  fragment ActionNote on ActionNote {
    id
    note
    createdTime
    createdBy {
      id
      firstName
      lastName
      email
    }
    action {
      title
      store {
        location {
          name
        }
      }
    }
  }
`
